import useApiQuery from 'shared/hooks/use-api-query';

import {CompanyProps} from 'modules/companies/types';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

const useCompaniesSelectData = () => {
  const {data = [], ...query} = useApiQuery<CompanyProps[]>({
    url: '/companies/all',
  });

  const {isFranchiseAccessControl} = useAccessControls();

  return {
    ...query,
    data: data?.map((company) => ({
      label: isFranchiseAccessControl
        ? `${company.name} (${company.city.name})`
        : company.name,
      value: company.id,
    })),
  };
};

export default useCompaniesSelectData;
